__turbopack_context__.v({
  "container": "AssetPathnameSegment-module__amHWQG__container",
  "endPathSegment": "AssetPathnameSegment-module__amHWQG__endPathSegment",
  "midPathSegment": "AssetPathnameSegment-module__amHWQG__midPathSegment",
  "pathnames": "AssetPathnameSegment-module__amHWQG__pathnames",
  "withLastPath": "AssetPathnameSegment-module__amHWQG__withLastPath",
  "withMidPath": "AssetPathnameSegment-module__amHWQG__withMidPath",
});
